import styled from "styled-components";
import { SeparatorMRVContainerProps } from "./SeparatorMRV.types";

const validateHeight = (height?: string): string => {
  return height && /^[0-9]+(px|%)$/.test(height) ? height : "50px";
};

const heightModifier = (height?: string): string => {
  if (height && /^[0-9]+(px)$/.test(height)) {
    const numericValue = parseInt(height, 10);
    if (numericValue > 0) {
      return validateHeight(`${numericValue + 2}px`);
    }
  }
  return validateHeight(height);
};

export const SeparatorMRVContainer = styled.div.attrs(() => ({
  "aria-hidden": "true",
  role: "presentation",
}))<SeparatorMRVContainerProps>`
  background-color: ${(props) => props.$backgroundcolor || "#FFFFFF"};
  height: ${(props) => heightModifier(props.$heightDesktop)};
  width: 100%;
  margin-top: -1px;
  margin-bottom: -1px;

  @media (max-width: 1024px) {
    height: ${(props) => heightModifier(props.$heightTablet)};
  }

  @media (max-width: 768px) {
    height: ${(props) => heightModifier(props.$heightMobile)};
  }
`;
